export const appTheme = {
	colors: {
		COLOR_BLACK: "#000000",
		COLOR_WHITE: "#FFFFFF",
		COLOR_OFF_WHITE: "#f9f9f9",
		COLOR_GRAY_TEXT: "#888",
		COLOR_GRAY_TEXT_DARK: "#666",
		COLOR_GRAY_TEXT_LIGHT: "#999",
		COLOR_DIVIDER_GRAY: "#DBDBDB",
		COLOR_BRAND_COLOR_LIGHT: "#EEEEDD",
		// Bridged to the Tailwind/shadcn CSS variables in src/styles/tailwind.css
		// so legacy (Chakra/styled-components) and Tailwind share one source of truth.
		COLOR_ACTION_BLUE: "hsl(var(--action))", // #219CD0
		COLOR_LIGHT_GRAY: "#F1F1F1",
		COLOR_DARK_GRAY: "#f2f2f2",
		COLOR_GRAY: "#CECECE",
		COLOR_LIGHT_BLUE: "#219CD085",
		COLOR_HOVER_ROW: "#EBF8FD",
		COLOR_DARK: "#333333",
		COLOR_ACNE_PRIMARY: "hsl(var(--brand))", // #4BB769 -> unified to Origo green
		COLOR_ACNE_SECONDARY: "#2E2E2E",
		COLOR_ORIGO_GREEN: "hsl(var(--brand))", // #49BD79
		COLOR_SUCCESS_LIGHT: "hsl(var(--success-muted))", // #bdecd1
		COLOR_DANGER: "hsl(var(--danger))", // #EB5757
		COLOR_DANGER_LIGHT: "hsl(var(--danger-muted))", // #FFEBEB
		BUTTON_GRAY: "#EFEFEF",
		BUTTON_TEXT_GRAY: "#5A5A5A",
		COLOR_TEXT_LIGHT: "#BDBDBD",
		COLOR_TRANSPARENT: "transparent",
		INPUT_BORDER: "#dbdbdb",
		INPUT_BORDER_FOCUSED: "#aaaaaa",
		COLOR_PLACEHOLDER_GRAY: "#E2E2E2",
		COLOR_LIGHT_BLUE2: "hsl(var(--info-muted))", // #D3EBF6
		COLOR_LIGHT_GRAY2: "#EDEDED",
		COLOR_BORDER_LIGHT: "#BDBDBD",
		COLOR_BACKGROUND_LIGHT: "#F5F5F5",
		COLOR_ORANGE: "hsl(var(--warning))", // #FF6B00
		PLACEHOLDER_TEXT: "#aaa",
		COLOR_BLUE_LIGHT: "hsl(var(--action))", // #219CD0
	},

	shades: {
		activeMenuItemBackground: "rgba(255, 255, 255, 0.15)",
		menuItemBackground: "rgba(255, 255, 255, 0.05)",
	},

	gradients: {},

	font: ["Roboto"],

	fontSizes: {
		FONT_SIZE_XXS: "0.625rem", // ~10px
		FONT_SIZE_XS: "0.75rem", // ~12px
		FONT_SIZE_S: "0.875rem", // ~14px
		FONT_SIZE_M: "0.9375rem", // ~15px
		FONT_SIZE_XMS: "1rem", // ~16px
		FONT_SIZE_XM: "1.0625rem", // ~17px
		FONT_SIZE_L: "1.125rem", // ~18px
		FONT_SIZE_XL: "2.875rem", // ~46px
	},

	fontWeight: {
		FONT_WEIGHT_REGULAR: "400",
		FONT_WEIGHT_MEDIUM: "500",
		FONT_WEIGHT_BOLD: "800",
	},

	dimensions: {},
};

export type AppTheme = typeof appTheme;
